import { render, staticRenderFns } from "./ShareHolderInfo.vue?vue&type=template&id=654f610c"
import script from "./ShareHolderInfo.vue?vue&type=script&lang=js"
export * from "./ShareHolderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports